import { NuxtAxiosInstance } from '@nuxtjs/axios'
import { Plugin } from '@nuxt/types'
import { AxiosError } from 'axios'

const axiosPlugin: Plugin = (context) => {
  context.$axios.onError((error: AxiosError) => {
    const response = error.response
    const code = response && response.status
    if (code === 401) {
      context.$auth
        .reset()
        .then(() => {
          context.store.$router.push('/login/')
        })
        .catch((error: any) => console.log(error))
    }
  })
}

export default axiosPlugin
